import { render } from "./ScaleKubernetesCluster.vue?vue&type=template&id=89b0facc&scoped=true"
import script from "./ScaleKubernetesCluster.vue?vue&type=script&lang=js"
export * from "./ScaleKubernetesCluster.vue?vue&type=script&lang=js"

import "./ScaleKubernetesCluster.vue?vue&type=style&index=0&id=89b0facc&scoped=true&lang=less"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89b0facc"]])

export default __exports__